<template>
<div class="receive-coupon">
  <van-popup v-model="selectShow" :overlay="false" class="popup" position="bottom">
    <van-picker ref="picker" show-toolbar cancel-button-text=" " @confirm="receiveCoupon" defaultIndex="0" :columns="serialList" value-key="name" @change="onChangeSelect" />
  </van-popup>
  <van-popup v-model="showPopup" class="popup" :class="selectShow?'receive-popup':''" :close-on-click-overlay="false" @click-overlay="selectShow=false">
    <div class="popup-wrap">
      <div class="popup-content">
        <div class="popup-title big-title" v-if="serialList.length>1">请选择意向车系</div>
        <div class="popup-title big-title" v-else>是否领取该车系优惠券？</div>
        <div class="popup-save">
          <div class="select" @click="handlerSelectShow" :class="[serialList.length>1?'select-bg':'']" >{{serial.name}}</div>
          <van-checkbox checked-color="#999" label-disabled="true" v-model="checked" shape="square" v-if="isShow">
            <span @click="jumpUrl">我已阅读并同意隐私政策</span>
          </van-checkbox>
          <button type="button" name="button" class="get-btn" @click="receiveCoupon">立即领取</button>
        </div>
      </div>
    </div>
    <div @click="close" class="popup-close"></div>
  </van-popup>
  <van-popup v-model="phonePopup" class="popup">
    <div class="popup-wrap">
      <div class="popup-content">
        <div class="popup-tip">
          领取成功，请在卡包中查看<br/>是否需要4s店专员与您联系，提供最优惠政策？
        </div>
        <div class="popup-bottom">
          <button type="button" name="button" @click="needPhone">需要</button>
          <button type="button" name="button" @click="phonePopup=false">不需要</button>
        </div>
      </div>
    </div>
  </van-popup>
</div>
</template>

<script>
import {
  getActivitySerialList,
  receiveCoupon
} from 'common/js/api'
import { getQueryString } from 'common/js/util'
export default {
  name: 'receive-coupon',
  data() {
    return {
      showPopup:  false,
      selectShow: false,
      coupon: {},
      serial: {},
      noSerial: {
        name: '请选择意向车系'
      },
      serialList: [],
      type: 0,
      checked: true,
      isShow: false,
      phonePopup:false
    }
  },
  watch: {
    showPopup(val) {
      if (!val) {
        this.selectShow = false
      }
    }
  },
  methods: {
    jumpUrl() {
      ap.pushWindow(`https://cat.pangku.com/static/agreement/index.html`)
    },
    close() {
      this.showPopup = false
      this.selectShow = false
    },
    handlerSelectShow() {
      this.selectShow = !this.selectShow
      if (this.selectShow&&this.$refs.picker) {
        this.$nextTick(() => {
          this.$refs.picker.setIndexes([0])
        })
      }
    },
    clickCoupon(coupon, type) {
      this.coupon = coupon
      this.type = type
      if (this.coupon.is_client === 1) {
        this.$toast(`你已领取${this.$state.brandInfo.name}专属优惠`)
      } else {
         this.getSerialList()
      }
    },
    onChangeSelect(vm, val) {
      this.serial = val
    },
    async getSerialList() {
      const res = await getActivitySerialList.call(this, this.$key, this.coupon.id)
      if (res.code === 0) {
        const list = res.data.list
        this.isShow = res.data.isShow
        if (list.length === 1) {
          this.serial = list[0]
          this.serialList = [...list]
        } else {
          this.serial = this.noSerial
          this.serialList = [...[this.noSerial], ...list]
        }
        this.showPopup = true
      } else {
        this.$toast(res.msg)
      }
    },
    receiveCoupon(coupon) {
      if (this.isShow && !this.checked) {
        this.$toast('需勾选须知说明才能领优惠券哦~')
        return
      }
      if (!this.serial.id) {
        this.$toast('车系不能为空')
        return
      }
      receiveCoupon
        .call(this, {
          baseURL: this.$baseURL.cat,
          url: `/coupon/${this.$key}/alipay`,
          data: {
            uid: this.$state.authInfo.uid,
            coupon: this.coupon,
            serial: this.serial,
            city: this.$state.city
          },
          params:{
            mid:getQueryString('mid'),
            type:2,
            other_type1:this.type
          }
        })
        .then(res => {
          if (res.success === true) {
            if(false){//去掉电联
               this.phonePopup = true
            }else{
              // this.$toast('领取成功，请在卡包中查看\n后续将有4S店专员为您提供最优惠政策')
            }
            this.coupon.is_client = 1
            this.showPopup = false
            this.selectShow = false
            const couponStore = this.$storejs.get(`${this.$key}Coupon`)||[]
            this.$storejs.set(`${this.$key}Coupon`,[...couponStore,this.coupon.id])
          } else {
            this.$toast(res.error_msg)
          }
        })
    },
    async needPhone(){
      const res = await this.$post({
        baseURL: this.$baseURL.cat,
        url: `/activity/${this.$key}/checkIn/coupon`,
        data: {
          coupon_id: this.coupon.id,
          coupon_title:this.coupon.title,
          series_id: this.serial.id,
          series_name: this.serial.name,
          location_amap: this.$state.city.longitude ? `${this.$state.city.longitude},${this.$state.city.latitude}` : '',
          location_province: this.$state.city.province,
          location_city: this.$state.city.city,
          mid:getQueryString('mid'),
          type:2,
          other_type1:this.type,
          isContact:1
        }
      })
      if (res.code === 0) {
        this.phonePopup = false
      } else {
        this.$toast(res.msg)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.van-checkbox /deep/ .van-checkbox__label {
    color: #fff;
}
.receive-coupon {
    .receive-popup {
        top: 30%;
    }
    .popup-tip{
      color:#fff;
      padding: 50px;
    }
    .popup-bottom{
      button{
        background: #fc9827;
        border:0;
        color:#fff;
        height:50px;
        line-height: 50px;
        border-radius: 50px;
        padding: 0 40px;
        margin:20px 20px 60px;
      }
    }
    .popup {
        .get-btn {
            width: 280px;
            text-align: center;
            line-height: 70px;
            border-radius: 38px;
            border: 0;
            background: #fdb92c;
            color: #fff;
            font-size: 30px;
            margin:40px auto;
        }
        .popup-wrap{
          padding: 20px;
        }
        .popup-content {
            position: relative;
            width:600px;
            margin: 0 auto;
            border-radius: 25px;
            text-align: center;
            background:  #b71f2a;
            border:4px solid #ea202e;
            .popup-title {
                height:150px;
                line-height: 150px;
                font-size: 36px;
                color:#fff;
            }
            .select.select-bg{
              background: url("../../img/select-bg.png") #a71822 no-repeat 400px center;
              background-size: 40px 40px;
            }
            .van-checkbox{
              margin:20px auto 0;
            }
            .select {
                border: 1px solid #a71822;
                background:#a71822;
                color:#fff;
                width: 460px;
                height: 70px;
                line-height: 70px;
                margin:0 auto;
                padding-left: 20px;
                box-sizing: border-box;
                font-size: 30px;
                border-radius: 5px;
                text-align: left;
            }
        }
    }
}
</style>
